export default __webpack_public_path__ + "locales/en/PreparationPortal.json?hash=a74c0e0c1ee9a33fcea1453fee82f00e";